// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: 'Oxanium', cursive;
}

::-webkit-scrollbar {
    width: 0.65rem;
}

::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px grey;
    border-radius: 10px;
}

::-webkit-scrollbar-thumb {
    background: #999;
    border-radius: 10px;
}

::-webkit-scrollbar-thumb:hover {
    background: #777;
    cursor: pointer;
}

input,
button {
    all: unset;
}

li {
    list-style: none;
}

.body-bg,
.compare-bg,
.dark-bg {
    position: relative;
}

.body-bg {
    background: radial-gradient(circle, #fff, #3498db);
    transition: background 0.5s ease-out;
}

.compare-bg {
    background: rgba(119, 119, 119, 1);
}

.dark-bg {
    background: #0f0f0f;
}

.flex,
.flex-load {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.pokedex {
    height: 90%;
    width: 55%;
    padding-top: 2%;
}

.pokedex-desktop,
.pokedex-desktop-close,
.pokedex-mobile {
    display: none;
}

.pokemon__image {
    position: absolute;
    height: 17%;
    width: 7%;
    bottom: 57%;
    left: 36.5%;
    transform: translate(-50%, 50%);
}

.pokemon__data {
    position: absolute;
    height: 20%;
    width: 17%;
    bottom: 57%;
    left: 36.5%;
    transform: translate(-49%, 170%);
    font-weight: 700;
    font-size: clamp(20px, 2vw, 30px);
    text-align: end;
    white-space: nowrap;
    overflow: hidden;
    background: linear-gradient(90deg, #0f0f0f, #222);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
}

.pokemon__name {
    text-transform: capitalize;
}

.form {
    position: absolute;
    height: 20%;
    width: 17%;
    bottom: 57%;
    left: 36.5%;
    transform: translate(-66%, 220%);
}

.input__search {
    height: 20%;
    width: 118%;
    padding: 4%;
    font-weight: 600;
    color: #0f0f0f;
    border-radius: 5px;
    border: solid 2px #0f0f0f;
    background-color: #e3e3e3;
    font-size: clamp(18px, 2vw, 22px);
    box-shadow: -5px 5px 0 #7c8282, -6px 6px 0 #0f0f0f;
}

.input__search:focus {
    background: #fff;
}

input[type='search']::-webkit-search-cancel-button {
    cursor: pointer;
}

.btns {
    position: absolute;
    height: 6%;
    width: 50%;
    bottom: 57%;
    left: 36.5%;
    display: flex;
    gap: 2.5%;
}

.btn {
    color: #fff;
    display: flex;
    justify-content: center;
    background: linear-gradient(90deg, #0f0f0f, #222);
    padding: 1.5%;
    width: 17%;
    font-weight: 600;
    font-size: clamp(18px, 2vw, 22px);
    border: solid 2px #0f0f0f;
    border-radius: 5px;
    box-shadow: -5px 5px 0 #444, -6px 6px 0 #0f0f0f;
    transform: translate(-110%, 840%);
    cursor: pointer;
}

.btn:hover {
    background: linear-gradient(90deg, #333, #222);
}

.btn:active {
    box-shadow: inset -3px 3px 0 #444, inset -4px 4px 0 #0f0f0f;
    font-size: 21px;
}

.flex-status {
    display: flex;
    position: absolute;
    height: 50%;
    width: 17%;
    bottom: 57%;
    left: 36.5%;
    transform: translate(112%, 90%);
    font-weight: 600;
    font-size: clamp(20px, 2vw, 23px);
    list-style: none;
}

.effect-text {
    background: linear-gradient(90deg, #0f0f0f, #222);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
}

.status {
    position: absolute;
    height: 20%;
    width: 17%;
    bottom: 57%;
    left: 36.5%;
    transform: translate(112%, 30%);
    font-weight: 700;
    font-size: clamp(20px, 2vw, 30px);
    text-align: center;
}

.stats {
    width: 65%;
}

.re-stats {
    width: 35%;
    text-align: end;
}

ul.stats.effect-text li,
ul.re-stats.effect-text li {
    margin-bottom: clamp(15px, 2vw, 20px);
}

.pokemon__type {
    position: absolute;
    text-align: center;
    height: 8%;
    width: 20%;
    bottom: 57%;
    left: 36.5%;
    transform: translate(87.5%, 600%);
    font-weight: 600;
    font-size: clamp(18px, 2vw, 20px);
}

div.pokemon__type ul.effect-text {
    display: flex;
    justify-content: center;
}

div.pokemon__type ul.effect-text li {
    padding: 1% 6%;
    margin: 3%;
    text-transform: capitalize;
    border-radius: 5px;
    box-shadow: -0.5px 0.5px 3px #0f0f0f, 0.5px -0.5px 3px #0f0f0f;
    color: #0f0f0f;
}

.gear {
    position: absolute;
    top: 2%;
    right: 1%;
    height: 5%;
    width: 2.5%;
    cursor: pointer;
    filter: invert(1);
}

.gear:hover {
    border-radius: 50%;
    filter: invert(0);
    transition: all 0.3s ease-in-out;
}

.menu-hidden {
    display: none;
}

.menu-flex {
    display: flex;
    flex-direction: column;
    width: 18%;
    position: absolute;
    right: 1%;
    top: 7.5%;
    border: 1px solid #0f0f0f;
    box-shadow: 0 0 2px #0f0f0f;
}

.bg-menu {
    display: none;
    background-color: rgb(227, 227, 227, 1);
    padding: clamp(28px, 2vw, 30px);
    border-radius: 10px;
    transition: all 0.4s ease-in-out;
}

.bg-menu.show,
.bg-info.show {
    display: block;
}

.div-flex {
    display: flex;
    justify-content: end;
    gap: 5%;
    padding: clamp(3px, 2vw, 6px);
    transform: translate(-18%, 0%);
}

.div-flex p {
    font-weight: 600;
}

#chk-1,
#chk-2,
#chk-3 {
    display: none;
}

.switch {
    position: relative;
    background-color: #777;
    width: clamp(40px, 2vw, 45px);
    height: clamp(18px, 2vw, 20px);
    border-radius: 20px;
    display: flex;
    align-items: center;
    padding: 1px;
    transition: all 0.5s ease-in-out;
    cursor: pointer;
}

.slider {
    position: absolute;
    background-color: #fff;
    border-radius: 50%;
    width: clamp(16px, 2vw, 18px);
    height: clamp(16px, 2vw, 18px);
    transition: all 0.5s ease-in-out;
}

#chk-1:checked ~ .switch,
#chk-2:checked ~ .switch,
#chk-3:checked ~ .switch {
    background: #2196f3;
}

#chk-1:checked ~ .switch .slider,
#chk-2:checked ~ .switch .slider,
#chk-3:checked ~ .switch .slider {
    transform: translate(clamp(18px, 2vw, 20px));
}

.loader {
    position: absolute;
    bottom: 54%;
    left: 34.5%;
    width: 60px;
    height: 60px;
    border: 5px solid #fff;
    border-bottom-color: transparent;
    border-radius: 50%;
    animation: rotation 1s linear infinite;
}

.loader__compare1 {
    z-index: 1;
    position: absolute;
    top: 27%;
    left: 25%;
    width: 60px;
    height: 60px;
    border: 5px solid #0f0f0f;
    border-bottom-color: transparent;
    border-radius: 50%;
    animation: rotation 1s linear infinite;
}

.loader__compare2 {
    z-index: 1;
    position: absolute;
    top: 27%;
    left: 70%;
    width: 60px;
    height: 60px;
    border: 5px solid #0f0f0f;
    border-bottom-color: transparent;
    border-radius: 50%;
    animation: rotation 1s linear infinite;
}

@keyframes rotation {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

.overlay {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    z-index: 1;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(119, 119, 119, 0.8);
}

.overlay.show {
    display: none;
}

.compare-vs {
    position: absolute;
    z-index: 1;
    width: 130px;
    height: 130px;
}

.vs__dark__compare {
    display: none;
}

.compare-pokemons {
    position: absolute;
    z-index: 1;
    top: 0;
    margin: 1.5%;
    padding: 0.5%;
    color: #fff;
    text-shadow: 1px 1px 2px rgba(15, 15, 15, 0.5),
        -1px -1px 2px rgba(15, 15, 15, 0.5);
}

.compare-close,
.compare-close-dark {
    position: absolute;
    top: 0;
    right: 0;
    width: 35px;
    height: 35px;
    margin: 2%;
    padding: 0.5%;
    filter: invert(1);
    cursor: pointer;
}

.compare-close-dark:hover {
    transition: all 0.3s ease-in-out;
    background-color: #888;
    padding: 0.3%;
    border-radius: 50%;
}

.compare-info-dark:hover {
    transition: all 0.3s ease-in-out;
    background-color: #888;
    padding: 0.6%;
    border-radius: 50%;
}

.compare-close:hover,
.compare-info:hover {
    transition: all 0.3s ease-in-out;
    filter: invert(0);
}

.compare-info,
.compare-info-dark {
    position: absolute;
    top: 0;
    left: 0;
    width: 40px;
    height: 40px;
    margin: 1.8%;
    padding: 0.5%;
    filter: invert(1);
    cursor: pointer;
}

.compare-container {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    height: 98%;
    width: 65%;
    background: radial-gradient(circle, #fff, rgba(52, 152, 219, 0.8));
    border-radius: 10px;
    border: solid 1px #0f0f0f;
}

.compare-container-dark {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    height: 98%;
    width: 65%;
    background: #0f0f0f;
    border-radius: 1%;
    border: solid 1px #0f0f0f;
}

.compare {
    display: flex;
    justify-content: center;
    position: relative;
    height: 80%;
    width: 40%;
    margin: 2.5%;
    background: #fff;
    border-radius: 10px;
    border: solid 2px #0f0f0f;
}

.compare-form1,
.compare-form2 {
    position: absolute;
    height: 20%;
    width: 40%;
    margin: 5% 5% 5% 2%;
    text-align: center;
    padding: 0.5%;
    transform: translate(0%, 10%);
}

.input__search__compare1,
.input__search__compare2 {
    height: 25%;
    width: 100%;
    padding: 2% 0% 2% 6%;
    font-weight: 600;
    color: #0f0f0f;
    border-radius: 5px;
    border: solid 2px #0f0f0f;
    background-color: #e5e5e5;
    font-size: clamp(18px, 2vw, 19px);
}

.input__search__compare1:focus,
.input__search__compare2:focus {
    background: #fff;
}

.compare-flex-status {
    display: flex;
    position: absolute;
    height: 50%;
    width: 75%;
    bottom: 57%;
    left: -10%;
    transform: translate(30%, 108%);
    font-weight: 600;
    font-size: clamp(18px, 2vw, 20px);
    list-style: none;
}

.compare-stats {
    width: 70%;
}

.compare-re-stats {
    width: 30%;
    text-align: end;
}

ul.compare-stats.effect-text li,
ul.compare-re-stats.effect-text li {
    margin-bottom: clamp(15px, 2vw, 19px);
}

.btn-compare {
    color: #0f0f0f;
    display: flex;
    justify-content: center;
    background: #e3e3e3;
    padding: 1.5%;
    width: 12%;
    font-weight: 600;
    font-size: clamp(18px, 2vw, 22px);
    border: solid 2px #0f0f0f;
    border-radius: 5px;
    transform: translate(36%, -360%);
    box-shadow: -5px 5px 0 #7f7f7f, -6px 6px 0 #0f0f0f;
    cursor: pointer;
}

.btn-compare:hover {
    background: #fff;
}

.btn-compare:active {
    box-shadow: inset -3px 3px 0 #7f7f7f, inset -4px 4px 0 #e3e3e3;
    font-size: 21px;
}

.pokemon__image__compare1,
.pokemon__image__compare2 {
    position: absolute;
    height: 20%;
    width: 20%;
    bottom: 57%;
    left: 36.5%;
    transform: translate(18%, -50%);
}

.pokemon__type__compare1,
.pokemon__type__compare2 {
    position: absolute;
    text-align: center;
    height: 8%;
    width: 20%;
    bottom: 57%;
    left: 36.5%;
    transform: translate(20.5%, 660%);
    font-weight: 600;
    font-size: clamp(18px, 2vw, 20px);
}

div.pokemon__type__compare1 ul.effect-text,
div.pokemon__type__compare2 ul.effect-text {
    display: flex;
    justify-content: center;
}

div.pokemon__type__compare1 ul.effect-text li,
div.pokemon__type__compare2 ul.effect-text li {
    padding: 4% 18%;
    margin: 8%;
    text-transform: capitalize;
    border-radius: 5px;
    box-shadow: -0.5px 0.5px 3px #0f0f0f, 0.5px -0.5px 3px #0f0f0f;
    color: #0f0f0f;
}

.pokemon__name__compare1,
.pokemon__name__compare2 {
    text-transform: capitalize;
}

.pokemon__data__compare1,
.pokemon__data__compare2 {
    position: absolute;
    text-align: center;
    height: 5%;
    width: 85%;
    font-weight: 700;
    font-size: clamp(20px, 2vw, 26px);
    transform: translate(0%, 720%);
    white-space: nowrap;
    overflow: hidden;
    background: linear-gradient(90deg, #0f0f0f, #222);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
}

.btn-compare-prev,
.btn-compare-next {
    z-index: 1;
    color: #0f0f0f;
    display: flex;
    background: #e3e3e3;
    padding: 8% 30% 20% 30%;
    font-weight: 600;
    font-size: clamp(18px, 2vw, 20px);
    border: solid 2px #0f0f0f;
    border-radius: 5px;
    transform: translate(-140%, 90%);
    cursor: pointer;
}

.btn-compare-prev:hover,
.btn-compare-next:hover {
    background-color: #fff;
}

.btn-compare-prev:active,
.btn-compare-next:active {
    background-color: #c0c0c0;
    font-size: clamp(17px, 2vw, 19px);
}

.btn-compare-prev {
    margin-right: 158%;
}

.btns-compare {
    display: flex;
    justify-content: space-between;
    height: 5.55%;
    width: 30%;
}

.defeat__compare1,
.draw__compare1,
.victory__compare1 {
    z-index: 2;
    position: absolute;
    height: 10%;
    width: 35%;
    border-radius: 5px;
    transform: translate(-65%, -200%);
    opacity: 0;
    animation: fadeInOut 3s infinite;
}

.defeat__compare2,
.draw__compare2,
.victory__compare2 {
    z-index: 2;
    position: absolute;
    height: 10%;
    width: 35%;
    border-radius: 5px;
    transform: translate(64%, -200%);
    opacity: 0;
    animation: fadeInOut 3s infinite;
}

@keyframes fadeInOut {
    0%,
    100% {
        opacity: 0;
    }

    50% {
        opacity: 0.8;
    }
}

.suggestions,
.suggestions__compare1,
.suggestions__compare2 {
    z-index: 3;
    position: absolute;
    overflow-y: auto;
    background: #e3e3e3;
    border: solid 2px #0f0f0f;
    border-radius: 5px;
    font-weight: 600;
    font-size: clamp(18px, 2vw, 22px);
}

.suggestions {
    max-height: 160px;
    width: 21.7%;
    box-shadow: -5px 5px 0 #7c8282, -6px 6px 0 #0f0f0f;
    top: 75.5%;
    transform: translate(-64%, 0%);
}

.suggestions__compare1,
.suggestions__compare2 {
    max-height: 575px;
    width: 89.5%;
    top: 14%;
}

.suggestions li,
.suggestions__compare1 li,
.suggestions__compare2 li {
    padding: 12px 13px;
    cursor: pointer;
}

.suggestions li:nth-child(odd),
.suggestions__compare1 li:nth-child(odd),
.suggestions__compare2 li:nth-child(odd) {
    background: #e3e3e3;
}

.suggestions li:nth-child(odd):hover,
.suggestions__compare1 li:nth-child(odd):hover,
.suggestions__compare2 li:nth-child(odd):hover {
    background: linear-gradient(90deg, #0f0f0f, #222);
    color: #e3e3e3;
}

.suggestions li:nth-child(even),
.suggestions__compare1 li:nth-child(even),
.suggestions__compare2 li:nth-child(even) {
    background: #c0c0c0;
}

.suggestions li:nth-child(even):hover,
.suggestions__compare1 li:nth-child(even):hover,
.suggestions__compare2 li:nth-child(even):hover {
    background: linear-gradient(90deg, #0f0f0f, #222);
    color: #e3e3e3;
}

.suggestions.hidden,
.suggestions__compare1.hidden,
.suggestions__compare2.hidden {
    display: none;
}

.flex-info {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    border-radius: 10px;
    padding: 30px 20px 20px 20px;
    margin: 10px;
    border: solid 1px #0f0f0f;
}

.bg-info {
    display: none;
    width: 95.5%;
    height: 90%;
    position: absolute;
    left: 2%;
    top: 7%;
    background-color: rgb(227, 227, 227, 1);
    padding: 20px;
    border-radius: 10px;
    border: 1px solid #0f0f0f;
    box-shadow: 0 0 2px #0f0f0f;
    transition: all 0.4s ease-in-out;
    z-index: 3;
}

.grid-info {
    display: grid;
    grid-template-columns: 1fr 1fr;
    justify-items: center;
    align-items: center;
}

.info-fight1,
.info-fight2 {
    position: absolute;
    z-index: 1;
    top: 0;
    margin: 4.5% 1.5% 1.5% 1.5%;
    padding: 0.5%;
    color: #0f0f0f;
}

.graph-adjustment {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 500px;
    width: 500px;
    margin-top: 20px;
}

.flex-status-buff-debuff {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 10px;
}

.compare-interrogation {
    width: 23px;
    height: 23px;
    margin-left: 8px;
    cursor: pointer;
}

.i-status1:hover + .i-status1-message,
.i-status2:hover + .i-status2-message,
.i-buff-debuff1:hover + .i-buff-debuff1-message,
.i-buff-debuff2:hover + .i-buff-debuff2-message,
.i-fraquezas:hover + .i-fraquezas-message {
    display: block;
}

.i-status1-message,
.i-status2-message,
.i-buff-debuff1-message,
.i-buff-debuff2-message,
.i-fraquezas-message {
    display: none;
    position: absolute;
    background-color: rgb(227, 227, 227, 1);
    padding: 20px;
    border-radius: 10px;
    border: 1px solid #0f0f0f;
    box-shadow: 0 0 2px #0f0f0f;
    transition: all 0.4s ease-in-out;
}

.i-status1-message {
    transform: translate(80%, -60%);
}

.i-status1-message,
.i-status2-message {
    width: 30%;
    height: 13%;
}

.i-buff-debuff1-message {
    transform: translate(68%, -60%);
}

.i-buff-debuff1-message,
.i-buff-debuff2-message {
    width: 50%;
    height: 20%;
}

.i-status2-message {
    transform: translate(-24%, -60%);
}

.i-buff-debuff2-message {
    transform: translate(-34%, -60%);
}

.div-fraquezas {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 1%;
}

.i-fraquezas-message {
    display: none;
    background-color: #fff !important;
    width: 95%;
    height: 86%;
    transform: translate(0%, -54%);
    z-index: 3;
}

.flex-fraquezas,
.flex-fraquezas-h2,
.flex-fraquezas-right {
    display: flex;
    justify-content: left;
    align-items: center;
}

.flex-fraquezas-h2 {
    justify-content: center !important;
    margin-bottom: 30px;
    margin-top: 10px;
}

.flex-fraquezas-right {
    justify-content: right;
}

.grid-fraquezas {
    display: grid;
    grid-template-columns: 1fr 1fr;
}

.fraqueza-types,
.fraqueza-types-three,
.fraqueza-types-four,
.fraqueza-types-five {
    padding: 0.5%;
    margin: 1.5%;
    text-transform: capitalize;
    border-radius: 5px;
    box-shadow: -0.5px 0.5px 3px #0f0f0f, 0.5px -0.5px 3px #0f0f0f;
    color: #0f0f0f;
    font-size: clamp(18px, 2vw, 20px);
    font-weight: 600;
    text-align: center;
    height: 6%;
    width: 20%;
}

.fraqueza-types-three,
.fraqueza-types-four,
.fraqueza-types-five {
    justify-content: left !important;
    margin: 0.7% !important;
    padding: 0.3% !important;
    height: 1% !important;
    width: 10% !important;
}

.red {
    color: red;
}

.bug {
    background: linear-gradient(
        180deg,
        rgb(158, 196, 47),
        rgb(158, 196, 47, 0.65)
    );
}

.dark {
    background: linear-gradient(
        180deg,
        rgb(97, 96, 113),
        rgb(97, 96, 113, 0.65)
    );
}

.dragon {
    background: linear-gradient(
        180deg,
        rgb(10, 120, 193),
        rgb(10, 120, 193, 0.65)
    );
}

.electric {
    background: linear-gradient(
        180deg,
        rgb(246, 217, 84),
        rgb(246, 217, 84, 0.65)
    );
}

.fairy {
    background: linear-gradient(
        180deg,
        rgb(237, 146, 228),
        rgb(237, 146, 228, 0.65)
    );
}

.fighting {
    background: linear-gradient(
        180deg,
        rgb(215, 66, 95),
        rgb(215, 66, 95, 0.65)
    );
}

.fire {
    background: linear-gradient(
        180deg,
        rgb(255, 163, 80),
        rgb(255, 163, 80, 0.65)
    );
}

.flying {
    background: linear-gradient(
        180deg,
        rgb(159, 185, 233),
        rgb(159, 185, 233, 0.65)
    );
}

.ghost {
    background: linear-gradient(
        180deg,
        rgb(106, 111, 198),
        rgb(106, 111, 198, 0.65)
    );
}

.grass {
    background: linear-gradient(
        180deg,
        rgb(92, 191, 104),
        rgb(92, 191, 104, 0.65)
    );
}

.ground {
    background: linear-gradient(
        180deg,
        rgb(215, 127, 79),
        rgb(215, 127, 79, 0.65)
    );
}

.ice {
    background: linear-gradient(
        180deg,
        rgb(128, 212, 201),
        rgb(128, 212, 201, 0.65)
    );
}

.normal {
    background: linear-gradient(
        180deg,
        rgb(157, 160, 160),
        rgb(157, 160, 160, 0.65)
    );
}

.poison {
    background: linear-gradient(
        180deg,
        rgb(188, 98, 208),
        rgb(188, 98, 208, 0.65)
    );
}

.psychic {
    background: linear-gradient(
        180deg,
        rgb(249, 119, 123),
        rgb(249, 119, 123, 0.65)
    );
}

.rock {
    background: linear-gradient(
        180deg,
        rgb(206, 192, 143),
        rgb(206, 192, 143, 0.65)
    );
}

.steel {
    background: linear-gradient(
        180deg,
        rgb(84, 143, 159),
        rgb(84, 143, 159, 0.65)
    );
}

.water {
    background: linear-gradient(
        180deg,
        rgb(86, 156, 217),
        rgb(86, 156, 217, 0.65)
    );
}

.fraquezaInfo1,
.fraquezaInfo2 {
    text-align: center;
    font-size: 18px;
}
`, "",{"version":3,"sources":["webpack://./src/css/style.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;IACtB,+BAA+B;AACnC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;;IAEI,UAAU;AACd;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;;IAGI,kBAAkB;AACtB;;AAEA;IACI,kDAAkD;IAClD,oCAAoC;AACxC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,UAAU;IACV,eAAe;AACnB;;AAEA;;;IAGI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,WAAW;IACX,WAAW;IACX,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,WAAW;IACX,WAAW;IACX,gCAAgC;IAChC,gBAAgB;IAChB,iCAAiC;IACjC,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,iDAAiD;IACjD,6BAA6B;IAC7B,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,WAAW;IACX,WAAW;IACX,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;IACzB,iCAAiC;IACjC,kDAAkD;AACtD;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,WAAW;IACX,WAAW;IACX,aAAa;IACb,SAAS;AACb;;AAEA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,iDAAiD;IACjD,aAAa;IACb,UAAU;IACV,gBAAgB;IAChB,iCAAiC;IACjC,yBAAyB;IACzB,kBAAkB;IAClB,+CAA+C;IAC/C,iCAAiC;IACjC,eAAe;AACnB;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,2DAA2D;IAC3D,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,WAAW;IACX,WAAW;IACX,+BAA+B;IAC/B,gBAAgB;IAChB,iCAAiC;IACjC,gBAAgB;AACpB;;AAEA;IACI,iDAAiD;IACjD,6BAA6B;IAC7B,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,WAAW;IACX,WAAW;IACX,+BAA+B;IAC/B,gBAAgB;IAChB,iCAAiC;IACjC,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;IACV,eAAe;AACnB;;AAEA;;IAEI,qCAAqC;AACzC;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,WAAW;IACX,WAAW;IACX,iCAAiC;IACjC,gBAAgB;IAChB,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,UAAU;IACV,0BAA0B;IAC1B,kBAAkB;IAClB,8DAA8D;IAC9D,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,UAAU;IACV,WAAW;IACX,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,uCAAuC;IACvC,+BAA+B;IAC/B,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,OAAO;IACP,6BAA6B;IAC7B,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;;IAGI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,6BAA6B;IAC7B,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,gCAAgC;IAChC,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,6BAA6B;IAC7B,8BAA8B;IAC9B,gCAAgC;AACpC;;AAEA;;;IAGI,mBAAmB;AACvB;;AAEA;;;IAGI,4CAA4C;AAChD;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,gCAAgC;IAChC,kBAAkB;IAClB,sCAAsC;AAC1C;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,gCAAgC;IAChC,kBAAkB;IAClB,sCAAsC;AAC1C;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,gCAAgC;IAChC,kBAAkB;IAClB,sCAAsC;AAC1C;;AAEA;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,OAAO;IACP,MAAM;IACN,WAAW;IACX,YAAY;IACZ,0CAA0C;AAC9C;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,MAAM;IACN,YAAY;IACZ,aAAa;IACb,WAAW;IACX;2CACuC;AAC3C;;AAEA;;IAEI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,UAAU;IACV,aAAa;IACb,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,gCAAgC;IAChC,sBAAsB;IACtB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,sBAAsB;IACtB,aAAa;IACb,kBAAkB;AACtB;;AAEA;;IAEI,gCAAgC;IAChC,iBAAiB;AACrB;;AAEA;;IAEI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,kEAAkE;IAClE,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,mBAAmB;IACnB,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;;IAEI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,6BAA6B;AACjC;;AAEA;;IAEI,WAAW;IACX,WAAW;IACX,oBAAoB;IACpB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;IACzB,iCAAiC;AACrC;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,WAAW;IACX,UAAU;IACV,+BAA+B;IAC/B,gBAAgB;IAChB,iCAAiC;IACjC,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;IACV,eAAe;AACnB;;AAEA;;IAEI,qCAAqC;AACzC;;AAEA;IACI,cAAc;IACd,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,UAAU;IACV,gBAAgB;IAChB,iCAAiC;IACjC,yBAAyB;IACzB,kBAAkB;IAClB,gCAAgC;IAChC,kDAAkD;IAClD,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,8DAA8D;IAC9D,eAAe;AACnB;;AAEA;;IAEI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,WAAW;IACX,WAAW;IACX,+BAA+B;AACnC;;AAEA;;IAEI,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,WAAW;IACX,WAAW;IACX,iCAAiC;IACjC,gBAAgB;IAChB,iCAAiC;AACrC;;AAEA;;IAEI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;;IAEI,eAAe;IACf,UAAU;IACV,0BAA0B;IAC1B,kBAAkB;IAClB,8DAA8D;IAC9D,cAAc;AAClB;;AAEA;;IAEI,0BAA0B;AAC9B;;AAEA;;IAEI,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,gBAAgB;IAChB,iCAAiC;IACjC,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;IAChB,iDAAiD;IACjD,6BAA6B;IAC7B,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;;IAEI,UAAU;IACV,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,iCAAiC;IACjC,yBAAyB;IACzB,kBAAkB;IAClB,gCAAgC;IAChC,eAAe;AACnB;;AAEA;;IAEI,sBAAsB;AAC1B;;AAEA;;IAEI,yBAAyB;IACzB,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,aAAa;IACb,UAAU;AACd;;AAEA;;;IAGI,UAAU;IACV,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,kBAAkB;IAClB,iCAAiC;IACjC,UAAU;IACV,gCAAgC;AACpC;;AAEA;;;IAGI,UAAU;IACV,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,kBAAkB;IAClB,gCAAgC;IAChC,UAAU;IACV,gCAAgC;AACpC;;AAEA;IACI;;QAEI,UAAU;IACd;;IAEA;QACI,YAAY;IAChB;AACJ;;AAEA;;;IAGI,UAAU;IACV,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,iCAAiC;AACrC;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,kDAAkD;IAClD,UAAU;IACV,8BAA8B;AAClC;;AAEA;;IAEI,iBAAiB;IACjB,YAAY;IACZ,QAAQ;AACZ;;AAEA;;;IAGI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;;;IAGI,mBAAmB;AACvB;;AAEA;;;IAGI,iDAAiD;IACjD,cAAc;AAClB;;AAEA;;;IAGI,mBAAmB;AACvB;;AAEA;;;IAGI,iDAAiD;IACjD,cAAc;AAClB;;AAEA;;;IAGI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;IACnB,4BAA4B;IAC5B,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,uCAAuC;IACvC,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,2BAA2B;IAC3B,gCAAgC;IAChC,UAAU;AACd;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;;IAEI,kBAAkB;IAClB,UAAU;IACV,MAAM;IACN,2BAA2B;IAC3B,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,eAAe;AACnB;;AAEA;;;;;IAKI,cAAc;AAClB;;AAEA;;;;;IAKI,aAAa;IACb,kBAAkB;IAClB,uCAAuC;IACvC,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,2BAA2B;IAC3B,gCAAgC;AACpC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;;IAEI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,+BAA+B;AACnC;;AAEA;;IAEI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,iCAAiC;IACjC,UAAU;IACV,WAAW;IACX,8BAA8B;IAC9B,UAAU;AACd;;AAEA;;;IAGI,aAAa;IACb,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,kCAAkC;IAClC,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;;;;IAII,aAAa;IACb,YAAY;IACZ,0BAA0B;IAC1B,kBAAkB;IAClB,8DAA8D;IAC9D,cAAc;IACd,iCAAiC;IACjC,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,UAAU;AACd;;AAEA;;;IAGI,gCAAgC;IAChC,uBAAuB;IACvB,wBAAwB;IACxB,qBAAqB;IACrB,qBAAqB;AACzB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI;;;;KAIC;AACL;;AAEA;IACI;;;;KAIC;AACL;;AAEA;IACI;;;;KAIC;AACL;;AAEA;IACI;;;;KAIC;AACL;;AAEA;IACI;;;;KAIC;AACL;;AAEA;IACI;;;;KAIC;AACL;;AAEA;IACI;;;;KAIC;AACL;;AAEA;IACI;;;;KAIC;AACL;;AAEA;IACI;;;;KAIC;AACL;;AAEA;IACI;;;;KAIC;AACL;;AAEA;IACI;;;;KAIC;AACL;;AAEA;IACI;;;;KAIC;AACL;;AAEA;IACI;;;;KAIC;AACL;;AAEA;IACI;;;;KAIC;AACL;;AAEA;IACI;;;;KAIC;AACL;;AAEA;IACI;;;;KAIC;AACL;;AAEA;IACI;;;;KAIC;AACL;;AAEA;IACI;;;;KAIC;AACL;;AAEA;;IAEI,kBAAkB;IAClB,eAAe;AACnB","sourcesContent":["* {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n    font-family: 'Oxanium', cursive;\n}\n\n::-webkit-scrollbar {\n    width: 0.65rem;\n}\n\n::-webkit-scrollbar-track {\n    box-shadow: inset 0 0 5px grey;\n    border-radius: 10px;\n}\n\n::-webkit-scrollbar-thumb {\n    background: #999;\n    border-radius: 10px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n    background: #777;\n    cursor: pointer;\n}\n\ninput,\nbutton {\n    all: unset;\n}\n\nli {\n    list-style: none;\n}\n\n.body-bg,\n.compare-bg,\n.dark-bg {\n    position: relative;\n}\n\n.body-bg {\n    background: radial-gradient(circle, #fff, #3498db);\n    transition: background 0.5s ease-out;\n}\n\n.compare-bg {\n    background: rgba(119, 119, 119, 1);\n}\n\n.dark-bg {\n    background: #0f0f0f;\n}\n\n.flex,\n.flex-load {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n}\n\n.pokedex {\n    height: 90%;\n    width: 55%;\n    padding-top: 2%;\n}\n\n.pokedex-desktop,\n.pokedex-desktop-close,\n.pokedex-mobile {\n    display: none;\n}\n\n.pokemon__image {\n    position: absolute;\n    height: 17%;\n    width: 7%;\n    bottom: 57%;\n    left: 36.5%;\n    transform: translate(-50%, 50%);\n}\n\n.pokemon__data {\n    position: absolute;\n    height: 20%;\n    width: 17%;\n    bottom: 57%;\n    left: 36.5%;\n    transform: translate(-49%, 170%);\n    font-weight: 700;\n    font-size: clamp(20px, 2vw, 30px);\n    text-align: end;\n    white-space: nowrap;\n    overflow: hidden;\n    background: linear-gradient(90deg, #0f0f0f, #222);\n    -webkit-background-clip: text;\n    background-clip: text;\n    color: transparent;\n}\n\n.pokemon__name {\n    text-transform: capitalize;\n}\n\n.form {\n    position: absolute;\n    height: 20%;\n    width: 17%;\n    bottom: 57%;\n    left: 36.5%;\n    transform: translate(-66%, 220%);\n}\n\n.input__search {\n    height: 20%;\n    width: 118%;\n    padding: 4%;\n    font-weight: 600;\n    color: #0f0f0f;\n    border-radius: 5px;\n    border: solid 2px #0f0f0f;\n    background-color: #e3e3e3;\n    font-size: clamp(18px, 2vw, 22px);\n    box-shadow: -5px 5px 0 #7c8282, -6px 6px 0 #0f0f0f;\n}\n\n.input__search:focus {\n    background: #fff;\n}\n\ninput[type='search']::-webkit-search-cancel-button {\n    cursor: pointer;\n}\n\n.btns {\n    position: absolute;\n    height: 6%;\n    width: 50%;\n    bottom: 57%;\n    left: 36.5%;\n    display: flex;\n    gap: 2.5%;\n}\n\n.btn {\n    color: #fff;\n    display: flex;\n    justify-content: center;\n    background: linear-gradient(90deg, #0f0f0f, #222);\n    padding: 1.5%;\n    width: 17%;\n    font-weight: 600;\n    font-size: clamp(18px, 2vw, 22px);\n    border: solid 2px #0f0f0f;\n    border-radius: 5px;\n    box-shadow: -5px 5px 0 #444, -6px 6px 0 #0f0f0f;\n    transform: translate(-110%, 840%);\n    cursor: pointer;\n}\n\n.btn:hover {\n    background: linear-gradient(90deg, #333, #222);\n}\n\n.btn:active {\n    box-shadow: inset -3px 3px 0 #444, inset -4px 4px 0 #0f0f0f;\n    font-size: 21px;\n}\n\n.flex-status {\n    display: flex;\n    position: absolute;\n    height: 50%;\n    width: 17%;\n    bottom: 57%;\n    left: 36.5%;\n    transform: translate(112%, 90%);\n    font-weight: 600;\n    font-size: clamp(20px, 2vw, 23px);\n    list-style: none;\n}\n\n.effect-text {\n    background: linear-gradient(90deg, #0f0f0f, #222);\n    -webkit-background-clip: text;\n    background-clip: text;\n    color: transparent;\n}\n\n.status {\n    position: absolute;\n    height: 20%;\n    width: 17%;\n    bottom: 57%;\n    left: 36.5%;\n    transform: translate(112%, 30%);\n    font-weight: 700;\n    font-size: clamp(20px, 2vw, 30px);\n    text-align: center;\n}\n\n.stats {\n    width: 65%;\n}\n\n.re-stats {\n    width: 35%;\n    text-align: end;\n}\n\nul.stats.effect-text li,\nul.re-stats.effect-text li {\n    margin-bottom: clamp(15px, 2vw, 20px);\n}\n\n.pokemon__type {\n    position: absolute;\n    text-align: center;\n    height: 8%;\n    width: 20%;\n    bottom: 57%;\n    left: 36.5%;\n    transform: translate(87.5%, 600%);\n    font-weight: 600;\n    font-size: clamp(18px, 2vw, 20px);\n}\n\ndiv.pokemon__type ul.effect-text {\n    display: flex;\n    justify-content: center;\n}\n\ndiv.pokemon__type ul.effect-text li {\n    padding: 1% 6%;\n    margin: 3%;\n    text-transform: capitalize;\n    border-radius: 5px;\n    box-shadow: -0.5px 0.5px 3px #0f0f0f, 0.5px -0.5px 3px #0f0f0f;\n    color: #0f0f0f;\n}\n\n.gear {\n    position: absolute;\n    top: 2%;\n    right: 1%;\n    height: 5%;\n    width: 2.5%;\n    cursor: pointer;\n    filter: invert(1);\n}\n\n.gear:hover {\n    border-radius: 50%;\n    filter: invert(0);\n    transition: all 0.3s ease-in-out;\n}\n\n.menu-hidden {\n    display: none;\n}\n\n.menu-flex {\n    display: flex;\n    flex-direction: column;\n    width: 18%;\n    position: absolute;\n    right: 1%;\n    top: 7.5%;\n    border: 1px solid #0f0f0f;\n    box-shadow: 0 0 2px #0f0f0f;\n}\n\n.bg-menu {\n    display: none;\n    background-color: rgb(227, 227, 227, 1);\n    padding: clamp(28px, 2vw, 30px);\n    border-radius: 10px;\n    transition: all 0.4s ease-in-out;\n}\n\n.bg-menu.show,\n.bg-info.show {\n    display: block;\n}\n\n.div-flex {\n    display: flex;\n    justify-content: end;\n    gap: 5%;\n    padding: clamp(3px, 2vw, 6px);\n    transform: translate(-18%, 0%);\n}\n\n.div-flex p {\n    font-weight: 600;\n}\n\n#chk-1,\n#chk-2,\n#chk-3 {\n    display: none;\n}\n\n.switch {\n    position: relative;\n    background-color: #777;\n    width: clamp(40px, 2vw, 45px);\n    height: clamp(18px, 2vw, 20px);\n    border-radius: 20px;\n    display: flex;\n    align-items: center;\n    padding: 1px;\n    transition: all 0.5s ease-in-out;\n    cursor: pointer;\n}\n\n.slider {\n    position: absolute;\n    background-color: #fff;\n    border-radius: 50%;\n    width: clamp(16px, 2vw, 18px);\n    height: clamp(16px, 2vw, 18px);\n    transition: all 0.5s ease-in-out;\n}\n\n#chk-1:checked ~ .switch,\n#chk-2:checked ~ .switch,\n#chk-3:checked ~ .switch {\n    background: #2196f3;\n}\n\n#chk-1:checked ~ .switch .slider,\n#chk-2:checked ~ .switch .slider,\n#chk-3:checked ~ .switch .slider {\n    transform: translate(clamp(18px, 2vw, 20px));\n}\n\n.loader {\n    position: absolute;\n    bottom: 54%;\n    left: 34.5%;\n    width: 60px;\n    height: 60px;\n    border: 5px solid #fff;\n    border-bottom-color: transparent;\n    border-radius: 50%;\n    animation: rotation 1s linear infinite;\n}\n\n.loader__compare1 {\n    z-index: 1;\n    position: absolute;\n    top: 27%;\n    left: 25%;\n    width: 60px;\n    height: 60px;\n    border: 5px solid #0f0f0f;\n    border-bottom-color: transparent;\n    border-radius: 50%;\n    animation: rotation 1s linear infinite;\n}\n\n.loader__compare2 {\n    z-index: 1;\n    position: absolute;\n    top: 27%;\n    left: 70%;\n    width: 60px;\n    height: 60px;\n    border: 5px solid #0f0f0f;\n    border-bottom-color: transparent;\n    border-radius: 50%;\n    animation: rotation 1s linear infinite;\n}\n\n@keyframes rotation {\n    0% {\n        transform: rotate(0deg);\n    }\n\n    100% {\n        transform: rotate(360deg);\n    }\n}\n\n.overlay {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: absolute;\n    z-index: 1;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(119, 119, 119, 0.8);\n}\n\n.overlay.show {\n    display: none;\n}\n\n.compare-vs {\n    position: absolute;\n    z-index: 1;\n    width: 130px;\n    height: 130px;\n}\n\n.vs__dark__compare {\n    display: none;\n}\n\n.compare-pokemons {\n    position: absolute;\n    z-index: 1;\n    top: 0;\n    margin: 1.5%;\n    padding: 0.5%;\n    color: #fff;\n    text-shadow: 1px 1px 2px rgba(15, 15, 15, 0.5),\n        -1px -1px 2px rgba(15, 15, 15, 0.5);\n}\n\n.compare-close,\n.compare-close-dark {\n    position: absolute;\n    top: 0;\n    right: 0;\n    width: 35px;\n    height: 35px;\n    margin: 2%;\n    padding: 0.5%;\n    filter: invert(1);\n    cursor: pointer;\n}\n\n.compare-close-dark:hover {\n    transition: all 0.3s ease-in-out;\n    background-color: #888;\n    padding: 0.3%;\n    border-radius: 50%;\n}\n\n.compare-info-dark:hover {\n    transition: all 0.3s ease-in-out;\n    background-color: #888;\n    padding: 0.6%;\n    border-radius: 50%;\n}\n\n.compare-close:hover,\n.compare-info:hover {\n    transition: all 0.3s ease-in-out;\n    filter: invert(0);\n}\n\n.compare-info,\n.compare-info-dark {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 40px;\n    height: 40px;\n    margin: 1.8%;\n    padding: 0.5%;\n    filter: invert(1);\n    cursor: pointer;\n}\n\n.compare-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: relative;\n    height: 98%;\n    width: 65%;\n    background: radial-gradient(circle, #fff, rgba(52, 152, 219, 0.8));\n    border-radius: 10px;\n    border: solid 1px #0f0f0f;\n}\n\n.compare-container-dark {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: relative;\n    height: 98%;\n    width: 65%;\n    background: #0f0f0f;\n    border-radius: 1%;\n    border: solid 1px #0f0f0f;\n}\n\n.compare {\n    display: flex;\n    justify-content: center;\n    position: relative;\n    height: 80%;\n    width: 40%;\n    margin: 2.5%;\n    background: #fff;\n    border-radius: 10px;\n    border: solid 2px #0f0f0f;\n}\n\n.compare-form1,\n.compare-form2 {\n    position: absolute;\n    height: 20%;\n    width: 40%;\n    margin: 5% 5% 5% 2%;\n    text-align: center;\n    padding: 0.5%;\n    transform: translate(0%, 10%);\n}\n\n.input__search__compare1,\n.input__search__compare2 {\n    height: 25%;\n    width: 100%;\n    padding: 2% 0% 2% 6%;\n    font-weight: 600;\n    color: #0f0f0f;\n    border-radius: 5px;\n    border: solid 2px #0f0f0f;\n    background-color: #e5e5e5;\n    font-size: clamp(18px, 2vw, 19px);\n}\n\n.input__search__compare1:focus,\n.input__search__compare2:focus {\n    background: #fff;\n}\n\n.compare-flex-status {\n    display: flex;\n    position: absolute;\n    height: 50%;\n    width: 75%;\n    bottom: 57%;\n    left: -10%;\n    transform: translate(30%, 108%);\n    font-weight: 600;\n    font-size: clamp(18px, 2vw, 20px);\n    list-style: none;\n}\n\n.compare-stats {\n    width: 70%;\n}\n\n.compare-re-stats {\n    width: 30%;\n    text-align: end;\n}\n\nul.compare-stats.effect-text li,\nul.compare-re-stats.effect-text li {\n    margin-bottom: clamp(15px, 2vw, 19px);\n}\n\n.btn-compare {\n    color: #0f0f0f;\n    display: flex;\n    justify-content: center;\n    background: #e3e3e3;\n    padding: 1.5%;\n    width: 12%;\n    font-weight: 600;\n    font-size: clamp(18px, 2vw, 22px);\n    border: solid 2px #0f0f0f;\n    border-radius: 5px;\n    transform: translate(36%, -360%);\n    box-shadow: -5px 5px 0 #7f7f7f, -6px 6px 0 #0f0f0f;\n    cursor: pointer;\n}\n\n.btn-compare:hover {\n    background: #fff;\n}\n\n.btn-compare:active {\n    box-shadow: inset -3px 3px 0 #7f7f7f, inset -4px 4px 0 #e3e3e3;\n    font-size: 21px;\n}\n\n.pokemon__image__compare1,\n.pokemon__image__compare2 {\n    position: absolute;\n    height: 20%;\n    width: 20%;\n    bottom: 57%;\n    left: 36.5%;\n    transform: translate(18%, -50%);\n}\n\n.pokemon__type__compare1,\n.pokemon__type__compare2 {\n    position: absolute;\n    text-align: center;\n    height: 8%;\n    width: 20%;\n    bottom: 57%;\n    left: 36.5%;\n    transform: translate(20.5%, 660%);\n    font-weight: 600;\n    font-size: clamp(18px, 2vw, 20px);\n}\n\ndiv.pokemon__type__compare1 ul.effect-text,\ndiv.pokemon__type__compare2 ul.effect-text {\n    display: flex;\n    justify-content: center;\n}\n\ndiv.pokemon__type__compare1 ul.effect-text li,\ndiv.pokemon__type__compare2 ul.effect-text li {\n    padding: 4% 18%;\n    margin: 8%;\n    text-transform: capitalize;\n    border-radius: 5px;\n    box-shadow: -0.5px 0.5px 3px #0f0f0f, 0.5px -0.5px 3px #0f0f0f;\n    color: #0f0f0f;\n}\n\n.pokemon__name__compare1,\n.pokemon__name__compare2 {\n    text-transform: capitalize;\n}\n\n.pokemon__data__compare1,\n.pokemon__data__compare2 {\n    position: absolute;\n    text-align: center;\n    height: 5%;\n    width: 85%;\n    font-weight: 700;\n    font-size: clamp(20px, 2vw, 26px);\n    transform: translate(0%, 720%);\n    white-space: nowrap;\n    overflow: hidden;\n    background: linear-gradient(90deg, #0f0f0f, #222);\n    -webkit-background-clip: text;\n    background-clip: text;\n    color: transparent;\n}\n\n.btn-compare-prev,\n.btn-compare-next {\n    z-index: 1;\n    color: #0f0f0f;\n    display: flex;\n    background: #e3e3e3;\n    padding: 8% 30% 20% 30%;\n    font-weight: 600;\n    font-size: clamp(18px, 2vw, 20px);\n    border: solid 2px #0f0f0f;\n    border-radius: 5px;\n    transform: translate(-140%, 90%);\n    cursor: pointer;\n}\n\n.btn-compare-prev:hover,\n.btn-compare-next:hover {\n    background-color: #fff;\n}\n\n.btn-compare-prev:active,\n.btn-compare-next:active {\n    background-color: #c0c0c0;\n    font-size: clamp(17px, 2vw, 19px);\n}\n\n.btn-compare-prev {\n    margin-right: 158%;\n}\n\n.btns-compare {\n    display: flex;\n    justify-content: space-between;\n    height: 5.55%;\n    width: 30%;\n}\n\n.defeat__compare1,\n.draw__compare1,\n.victory__compare1 {\n    z-index: 2;\n    position: absolute;\n    height: 10%;\n    width: 35%;\n    border-radius: 5px;\n    transform: translate(-65%, -200%);\n    opacity: 0;\n    animation: fadeInOut 3s infinite;\n}\n\n.defeat__compare2,\n.draw__compare2,\n.victory__compare2 {\n    z-index: 2;\n    position: absolute;\n    height: 10%;\n    width: 35%;\n    border-radius: 5px;\n    transform: translate(64%, -200%);\n    opacity: 0;\n    animation: fadeInOut 3s infinite;\n}\n\n@keyframes fadeInOut {\n    0%,\n    100% {\n        opacity: 0;\n    }\n\n    50% {\n        opacity: 0.8;\n    }\n}\n\n.suggestions,\n.suggestions__compare1,\n.suggestions__compare2 {\n    z-index: 3;\n    position: absolute;\n    overflow-y: auto;\n    background: #e3e3e3;\n    border: solid 2px #0f0f0f;\n    border-radius: 5px;\n    font-weight: 600;\n    font-size: clamp(18px, 2vw, 22px);\n}\n\n.suggestions {\n    max-height: 160px;\n    width: 21.7%;\n    box-shadow: -5px 5px 0 #7c8282, -6px 6px 0 #0f0f0f;\n    top: 75.5%;\n    transform: translate(-64%, 0%);\n}\n\n.suggestions__compare1,\n.suggestions__compare2 {\n    max-height: 575px;\n    width: 89.5%;\n    top: 14%;\n}\n\n.suggestions li,\n.suggestions__compare1 li,\n.suggestions__compare2 li {\n    padding: 12px 13px;\n    cursor: pointer;\n}\n\n.suggestions li:nth-child(odd),\n.suggestions__compare1 li:nth-child(odd),\n.suggestions__compare2 li:nth-child(odd) {\n    background: #e3e3e3;\n}\n\n.suggestions li:nth-child(odd):hover,\n.suggestions__compare1 li:nth-child(odd):hover,\n.suggestions__compare2 li:nth-child(odd):hover {\n    background: linear-gradient(90deg, #0f0f0f, #222);\n    color: #e3e3e3;\n}\n\n.suggestions li:nth-child(even),\n.suggestions__compare1 li:nth-child(even),\n.suggestions__compare2 li:nth-child(even) {\n    background: #c0c0c0;\n}\n\n.suggestions li:nth-child(even):hover,\n.suggestions__compare1 li:nth-child(even):hover,\n.suggestions__compare2 li:nth-child(even):hover {\n    background: linear-gradient(90deg, #0f0f0f, #222);\n    color: #e3e3e3;\n}\n\n.suggestions.hidden,\n.suggestions__compare1.hidden,\n.suggestions__compare2.hidden {\n    display: none;\n}\n\n.flex-info {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    background-color: #fff;\n    border-radius: 10px;\n    padding: 30px 20px 20px 20px;\n    margin: 10px;\n    border: solid 1px #0f0f0f;\n}\n\n.bg-info {\n    display: none;\n    width: 95.5%;\n    height: 90%;\n    position: absolute;\n    left: 2%;\n    top: 7%;\n    background-color: rgb(227, 227, 227, 1);\n    padding: 20px;\n    border-radius: 10px;\n    border: 1px solid #0f0f0f;\n    box-shadow: 0 0 2px #0f0f0f;\n    transition: all 0.4s ease-in-out;\n    z-index: 3;\n}\n\n.grid-info {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    justify-items: center;\n    align-items: center;\n}\n\n.info-fight1,\n.info-fight2 {\n    position: absolute;\n    z-index: 1;\n    top: 0;\n    margin: 4.5% 1.5% 1.5% 1.5%;\n    padding: 0.5%;\n    color: #0f0f0f;\n}\n\n.graph-adjustment {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 500px;\n    width: 500px;\n    margin-top: 20px;\n}\n\n.flex-status-buff-debuff {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-bottom: 10px;\n}\n\n.compare-interrogation {\n    width: 23px;\n    height: 23px;\n    margin-left: 8px;\n    cursor: pointer;\n}\n\n.i-status1:hover + .i-status1-message,\n.i-status2:hover + .i-status2-message,\n.i-buff-debuff1:hover + .i-buff-debuff1-message,\n.i-buff-debuff2:hover + .i-buff-debuff2-message,\n.i-fraquezas:hover + .i-fraquezas-message {\n    display: block;\n}\n\n.i-status1-message,\n.i-status2-message,\n.i-buff-debuff1-message,\n.i-buff-debuff2-message,\n.i-fraquezas-message {\n    display: none;\n    position: absolute;\n    background-color: rgb(227, 227, 227, 1);\n    padding: 20px;\n    border-radius: 10px;\n    border: 1px solid #0f0f0f;\n    box-shadow: 0 0 2px #0f0f0f;\n    transition: all 0.4s ease-in-out;\n}\n\n.i-status1-message {\n    transform: translate(80%, -60%);\n}\n\n.i-status1-message,\n.i-status2-message {\n    width: 30%;\n    height: 13%;\n}\n\n.i-buff-debuff1-message {\n    transform: translate(68%, -60%);\n}\n\n.i-buff-debuff1-message,\n.i-buff-debuff2-message {\n    width: 50%;\n    height: 20%;\n}\n\n.i-status2-message {\n    transform: translate(-24%, -60%);\n}\n\n.i-buff-debuff2-message {\n    transform: translate(-34%, -60%);\n}\n\n.div-fraquezas {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-top: 1%;\n}\n\n.i-fraquezas-message {\n    display: none;\n    background-color: #fff !important;\n    width: 95%;\n    height: 86%;\n    transform: translate(0%, -54%);\n    z-index: 3;\n}\n\n.flex-fraquezas,\n.flex-fraquezas-h2,\n.flex-fraquezas-right {\n    display: flex;\n    justify-content: left;\n    align-items: center;\n}\n\n.flex-fraquezas-h2 {\n    justify-content: center !important;\n    margin-bottom: 30px;\n    margin-top: 10px;\n}\n\n.flex-fraquezas-right {\n    justify-content: right;\n}\n\n.grid-fraquezas {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n}\n\n.fraqueza-types,\n.fraqueza-types-three,\n.fraqueza-types-four,\n.fraqueza-types-five {\n    padding: 0.5%;\n    margin: 1.5%;\n    text-transform: capitalize;\n    border-radius: 5px;\n    box-shadow: -0.5px 0.5px 3px #0f0f0f, 0.5px -0.5px 3px #0f0f0f;\n    color: #0f0f0f;\n    font-size: clamp(18px, 2vw, 20px);\n    font-weight: 600;\n    text-align: center;\n    height: 6%;\n    width: 20%;\n}\n\n.fraqueza-types-three,\n.fraqueza-types-four,\n.fraqueza-types-five {\n    justify-content: left !important;\n    margin: 0.7% !important;\n    padding: 0.3% !important;\n    height: 1% !important;\n    width: 10% !important;\n}\n\n.red {\n    color: red;\n}\n\n.bug {\n    background: linear-gradient(\n        180deg,\n        rgb(158, 196, 47),\n        rgb(158, 196, 47, 0.65)\n    );\n}\n\n.dark {\n    background: linear-gradient(\n        180deg,\n        rgb(97, 96, 113),\n        rgb(97, 96, 113, 0.65)\n    );\n}\n\n.dragon {\n    background: linear-gradient(\n        180deg,\n        rgb(10, 120, 193),\n        rgb(10, 120, 193, 0.65)\n    );\n}\n\n.electric {\n    background: linear-gradient(\n        180deg,\n        rgb(246, 217, 84),\n        rgb(246, 217, 84, 0.65)\n    );\n}\n\n.fairy {\n    background: linear-gradient(\n        180deg,\n        rgb(237, 146, 228),\n        rgb(237, 146, 228, 0.65)\n    );\n}\n\n.fighting {\n    background: linear-gradient(\n        180deg,\n        rgb(215, 66, 95),\n        rgb(215, 66, 95, 0.65)\n    );\n}\n\n.fire {\n    background: linear-gradient(\n        180deg,\n        rgb(255, 163, 80),\n        rgb(255, 163, 80, 0.65)\n    );\n}\n\n.flying {\n    background: linear-gradient(\n        180deg,\n        rgb(159, 185, 233),\n        rgb(159, 185, 233, 0.65)\n    );\n}\n\n.ghost {\n    background: linear-gradient(\n        180deg,\n        rgb(106, 111, 198),\n        rgb(106, 111, 198, 0.65)\n    );\n}\n\n.grass {\n    background: linear-gradient(\n        180deg,\n        rgb(92, 191, 104),\n        rgb(92, 191, 104, 0.65)\n    );\n}\n\n.ground {\n    background: linear-gradient(\n        180deg,\n        rgb(215, 127, 79),\n        rgb(215, 127, 79, 0.65)\n    );\n}\n\n.ice {\n    background: linear-gradient(\n        180deg,\n        rgb(128, 212, 201),\n        rgb(128, 212, 201, 0.65)\n    );\n}\n\n.normal {\n    background: linear-gradient(\n        180deg,\n        rgb(157, 160, 160),\n        rgb(157, 160, 160, 0.65)\n    );\n}\n\n.poison {\n    background: linear-gradient(\n        180deg,\n        rgb(188, 98, 208),\n        rgb(188, 98, 208, 0.65)\n    );\n}\n\n.psychic {\n    background: linear-gradient(\n        180deg,\n        rgb(249, 119, 123),\n        rgb(249, 119, 123, 0.65)\n    );\n}\n\n.rock {\n    background: linear-gradient(\n        180deg,\n        rgb(206, 192, 143),\n        rgb(206, 192, 143, 0.65)\n    );\n}\n\n.steel {\n    background: linear-gradient(\n        180deg,\n        rgb(84, 143, 159),\n        rgb(84, 143, 159, 0.65)\n    );\n}\n\n.water {\n    background: linear-gradient(\n        180deg,\n        rgb(86, 156, 217),\n        rgb(86, 156, 217, 0.65)\n    );\n}\n\n.fraquezaInfo1,\n.fraquezaInfo2 {\n    text-align: center;\n    font-size: 18px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
